var map = {
	"./icons-white/add-new.png": 6396,
	"./icons-white/add.png": 1313,
	"./icons-white/adjust.png": 9143,
	"./icons-white/archive.png": 1886,
	"./icons-white/back.png": 8899,
	"./icons-white/briefcase.png": 2596,
	"./icons-white/camera.png": 5893,
	"./icons-white/chain.png": 4119,
	"./icons-white/clock.png": 2899,
	"./icons-white/close.png": 9841,
	"./icons-white/cloud-done.png": 2558,
	"./icons-white/copy.png": 5033,
	"./icons-white/delete.png": 3844,
	"./icons-white/dot-bricks.png": 4457,
	"./icons-white/down-arrow.png": 2958,
	"./icons-white/edit.png": 6412,
	"./icons-white/envelope.png": 1291,
	"./icons-white/external-link.png": 4805,
	"./icons-white/forward.png": 9991,
	"./icons-white/heart.png": 9689,
	"./icons-white/help.png": 111,
	"./icons-white/home.png": 8917,
	"./icons-white/left-arrow.png": 5114,
	"./icons-white/line.png": 7330,
	"./icons-white/link.png": 7121,
	"./icons-white/lock.png": 6578,
	"./icons-white/love.png": 3225,
	"./icons-white/microphone.png": 3688,
	"./icons-white/minus-math.png": 4797,
	"./icons-white/minus.png": 7873,
	"./icons-white/paper-plane.png": 2188,
	"./icons-white/pause.png": 3413,
	"./icons-white/play.png": 2591,
	"./icons-white/plus-math.png": 9875,
	"./icons-white/portraits.png": 4365,
	"./icons-white/protect.png": 1000,
	"./icons-white/reduce.png": 4179,
	"./icons-white/search.png": 4747,
	"./icons-white/settings.png": 8949,
	"./icons-white/share.png": 7572,
	"./icons-white/shield.png": 7270,
	"./icons-white/slider.png": 1275,
	"./icons-white/star-filled.png": 1662,
	"./icons-white/star.png": 9371,
	"./icons-white/unsplash.png": 2372,
	"./icons-white/up-arrow.png": 1202,
	"./icons-white/upload-to-cloud.png": 3658,
	"./icons-white/upload.png": 6039,
	"./icons-white/user.png": 2633,
	"./icons/add-new.png": 6217,
	"./icons/add.png": 648,
	"./icons/adjust.png": 4620,
	"./icons/archive.png": 8655,
	"./icons/back.png": 8987,
	"./icons/briefcase.png": 7284,
	"./icons/camera.png": 555,
	"./icons/chain.png": 7025,
	"./icons/clock.png": 1693,
	"./icons/cloud-done.png": 3340,
	"./icons/copy.png": 9485,
	"./icons/delete.png": 4533,
	"./icons/dot-bricks.png": 4296,
	"./icons/edit.png": 2006,
	"./icons/envelope.png": 2003,
	"./icons/external-link.png": 4952,
	"./icons/forward.png": 2844,
	"./icons/heart-2.png": 4712,
	"./icons/heart.png": 1036,
	"./icons/home.png": 1523,
	"./icons/left-arrow.png": 4436,
	"./icons/line.png": 9744,
	"./icons/link.png": 3433,
	"./icons/lock-2.png": 8812,
	"./icons/lock.png": 1481,
	"./icons/love.png": 9590,
	"./icons/microphone.png": 9280,
	"./icons/minus.png": 9661,
	"./icons/paper-plane.png": 8760,
	"./icons/pause.png": 2242,
	"./icons/play.png": 9022,
	"./icons/plus-math.png": 969,
	"./icons/portraits.png": 1280,
	"./icons/protect.png": 2427,
	"./icons/reduce.png": 8966,
	"./icons/search.png": 7404,
	"./icons/settings.png": 6827,
	"./icons/share.png": 5818,
	"./icons/shield.png": 3482,
	"./icons/slider.png": 9267,
	"./icons/star-2.png": 919,
	"./icons/star-filled.png": 1756,
	"./icons/star.png": 5629,
	"./icons/subtract.png": 734,
	"./icons/unsplash.png": 3875,
	"./icons/upload-to-cloud.png": 2687,
	"./icons/upload.png": 2621,
	"./icons/user.png": 1400
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7405;